import { PlatformType } from '@/main/model/PlatformType';
import { Profile, OnboardingStatus } from '../model/AuthTypes';

export const isOnboardingCompleted = (profile: Profile) => {
  return profile.onboarding_status === OnboardingStatus.OnboardingComplete;
};

export const isHmallProfile = (profile?: Profile | null): boolean => {
  if(!profile) return false;
  return profile.platform_type === PlatformType.hmall;
};

export const isCafe24Profile = (profile?: Profile | null): boolean => {
  if(!profile) return false;
  return profile.platform_type === PlatformType.cafe24;
};

export const isLaroseeProfile = (profile?: Profile | null): boolean => {
  if(!profile) return false;
  return profile.platform_type === PlatformType.larosee;
};